@if (wrapper && wrapper.isReady) {
  <form [formGroup]="wrapper.form" (ngSubmit)="onFormSubmit()">
    <ng-content></ng-content>
    <input #submit type="submit" class="hidden">
  </form>
}

@if (wrapper && wrapper.hasValidationErrors()) {
  <div class="container acc-form-validation-error mt-3">
    <div class="col">
      <div class="row">
        <div class="alert alert-danger" role="alert">
          @for (error of wrapper.getValidationErrors(); track error) {
            <div>
              <div>
                <span>{{ error.messageCode|translate }}</span>
                @if (error.errorCode) {
                  <span>
                    ({{ 'validation.code'|translate }} <code>{{ error.errorCode }}</code>)
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (wrapper && (wrapper.hasExceptions() || hasGeneralErrors())) {
  <div class="container acc-form-exception mt-3">
    <div class="col">
      <div class="row">
        <div class="alert alert-danger" role="alert">
          @for (ex of wrapper.getExceptions(); track ex) {
            <div>
              <div>
                <span>{{ buildExceptionMessage(ex) }}</span>
                @if (ex.code) {
                  <span> ({{ 'validation.code'|translate }} <code>{{ ex.code }}</code>)</span>
                }
              </div>
              <!--
              @if (ex.exceptionClass && log.isDebugEnabled()) {
                <div>
                  <span class="fst-italic">{{ ex.exceptionClass }}</span>
                </div>
              }
              -->
            </div>
          }
          @for (errorCode of getGeneralErrors(); track errorCode) {
            <div>
              <div>{{ 'validation.' + errorCode|translate }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

<acc-form-footer [wrapper]="wrapper" [showFooter]="showFooter"/>
